module.exports = __webpack_public_path__ + "static/media/partnership.f2cef4f0.jpg";